import { useCallback } from 'react';
import type {
  PinOnImageResult,
  CorrectArea,
} from '@core-api/presentation/types/response';
import {
  usePreviewResultsIterator,
  getPinOnImagePreviewResultsIteration,
} from '@mentimeter/slides-preview-results';

interface UsePinOnImagePreviewResultsProps {
  isEnabled: boolean;
  correctArea: CorrectArea | null;
}

const previewResultsInterval = () => Math.random() * 1000 + 500;

export const usePinOnImagePreviewResults = ({
  isEnabled,
  correctArea,
}: UsePinOnImagePreviewResultsProps): PinOnImageResult[] => {
  const getNextResults = useCallback(
    (iteration: number, previous: PinOnImageResult[] = []) => {
      return getPinOnImagePreviewResultsIteration({
        iteration,
        previous,
        extras: { correctArea },
      });
    },
    [correctArea],
  );

  return (
    usePreviewResultsIterator(
      isEnabled,
      getNextResults,
      previewResultsInterval,
    ) ?? []
  );
};
